import {
    useBuscarHelper,
  } from "../../../Commons/Scripts/Utils/webservice-helper.js"; 
import { 
  URL_TOP10_DASHBOARD, 
  URL_TARJETAS_DASHBOARD,
  URL_GRAFICOS_FACTURAS_DASHBOARD,
  URL_GRAFICOS_ANTICIPOS_DASHBOARD,
  URL_GRAFICOS_PAGOS_DASHBOARD,
  URL_GRAFICOS_ORDENES_COMPRA_DASHBOARD,
  URL_GRAFICOS_NOTAS_DEBITO_DASHBOARD,
  URL_GRAFICOS_NOTAS_CREDITO_DASHBOARD,
  URL_GRAFICOS_TASAS_DASHBOARD,
  URL_GRAFICOS_ORDENES_COMPRA_TRANSITO_DASHBOARD,
  URL_GRAFICOS_ORDENES_COMPRA_LIQUIDACION_DASHBOARD,
  URL_GRAFICOS_ORDENES_COMPRA_EN_ALMACEN_DASHBOARD,
  URL_GRID_SUPLIDORES_DASHBOARD,
  URL_SUPLIDRES_AUTOCOMPLETE_GRID
 } from '../../../CxP/Scripts/Utils/constantes.js'

  export const useBuscarTarjetasDashboard = (cuerpo) => {
    const url = URL_TARJETAS_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return {data, loading, error};
  };

  export const useBuscarTop10Dashboard = (cuerpo) => {
    const url = URL_TOP10_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return {data, loading, error};
  };

  export const useBuscarFacturasGraficoDashboard = (cuerpo) => {
    const url = URL_GRAFICOS_FACTURAS_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo)
    return { data, loading, error };
  }

  export const useBuscarAnticposGraficoDashboard = (cuerpo) => {
    const url = URL_GRAFICOS_ANTICIPOS_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo)
    return { data, loading, error };
  }
  export const useBuscarPagosGraficoDashboard = (cuerpo) => {
    const url = URL_GRAFICOS_PAGOS_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo)
    return { data, loading, error };
  }
  export const useBuscarOrdenesCompraGraficoDashboard = (cuerpo) => {
    const url = URL_GRAFICOS_ORDENES_COMPRA_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo)
    return { data, loading, error };
  }
  export const useBuscarNotasDebitoGraficoDashboard = (cuerpo) => {
    const url = URL_GRAFICOS_NOTAS_DEBITO_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo)
    return { data, loading, error };
  }
  export const useBuscarNotasCreditoGraficoDashboard = (cuerpo) => {
    const url = URL_GRAFICOS_NOTAS_CREDITO_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo)
    return { data, loading, error };
  }
  export const useBuscarTasasGraficoDashboard = (cuerpo) => {
    const url = URL_GRAFICOS_TASAS_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo)
    return { data, loading, error };
  }
  export const useBuscarOrdenesCompraTransitoGraficoDashboard = (cuerpo) => {
    const url = URL_GRAFICOS_ORDENES_COMPRA_TRANSITO_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo)
    return { data, loading, error };
  }
  export const useBuscarOrdenesCompraLiquidacionGraficoDashboard = (cuerpo) => {
    const url = URL_GRAFICOS_ORDENES_COMPRA_LIQUIDACION_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo)
    return { data, loading, error };
  }
  export const useBuscarOrdenesCompraEnAlmacenGraficoDashboard = (cuerpo) => {
    const url = URL_GRAFICOS_ORDENES_COMPRA_EN_ALMACEN_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo)
    return { data, loading, error };
  }

  export const useBuscarGridSuplidoresDashboard = (cuerpo) => {
    const url = URL_GRID_SUPLIDORES_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo)
    return { data, loading, error };
  }
  export const useBuscarSuplidoresAutoComplete = (cuerpo) => {
    const url = URL_SUPLIDRES_AUTOCOMPLETE_GRID;
    const { data, loading, error } = useBuscarHelper(url, cuerpo)
    return { data, loading, error };
  }